"use client";

import { Typography } from "@/components/ui/typography";
import type { AboutUsSupportProps } from "./types";
import { aboutUsSupportData } from "./constants";
import { memo } from "react";
import { SupportCardsCarousel } from "@/components/screen/global-components/support";

const AboutUsSupport = ({}: AboutUsSupportProps) => {
  const { title, description, cards } = aboutUsSupportData;

  return (
    <section className="section overflow-hidden bg-white lg:bg-background-secondary">
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col gap-4 md:justify-center md:gap-2 md:w-full md:max-w-[784] md:mx-auto md:text-center md:hidden">
          <Typography variant="heading4">
            <h2>{title}</h2>
          </Typography>
          {!!description && (
            <div className="flex justify-center text-gray-600">
              <Typography variant="subHeadingSm" asChild>
                <p>{description}</p>
              </Typography>
            </div>
          )}
        </div>
        <SupportCardsCarousel cards={cards} className="mt-6 md:mt-0 lg:!grid-cols-4" imageCardRatioBoost />
      </div>
    </section>
  );
};

export default memo(AboutUsSupport);
